import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FeederContractModel } from '@bo-client/activation-management/feeder-contract/model/feeder-contract.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-feeder-contract-summary',
  templateUrl: './feeder-contract-summary.component.html',
  styleUrls: ['../../../shared/summaries/css-summary.component.scss']
})
export class FeederContractSummaryComponent implements OnInit, OnDestroy {
  @Input() feederContract: FeederContractModel;
  @Input() title: string;

  private compUnsubs$ = new Subject<void>();

  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
